$(document).ready(function () {


  function mainProductQuantityProcess () {
    const quantityInput = $('.main-product__input-quantity')
    const quantity = Number(quantityInput.val())
    const maxQuantity = Number(quantityInput.attr('max'))
    if ($(this).hasClass('main-product__quantity-btn--plus')) {
      if(quantity === 1) {
        $('.main-product__quantity-btn--minus').removeClass('disabled')
      }
      const newQuantity = quantity + 1
      if (newQuantity === maxQuantity) {
        $(this).addClass('disabled')
      }
      quantityInput.attr('value', newQuantity)
      $('.main-product__quantity-value').text(`${newQuantity}`)
    }else if ($(this).hasClass('main-product__quantity-btn--minus')) {
      const newQuantity = quantity - 1
      if (newQuantity === 1) {
        $(this).addClass('disabled')
      }
      quantityInput.attr('value', newQuantity)
      $('.main-product__quantity-value').text(`${newQuantity}`)
    }
  }

  $('.main-product__quantity-btn').on('click', mainProductQuantityProcess)
  $('.main-product__variant-select').on('change', function () {
    document.dispatchEvent( new CustomEvent("variantChanged", { detail: { variantId: $(this).val() } }) );
  })

})
$(document).ready(function () {
  if (!variantPricesHint) {
    return
  }
  if(variantPricesHint[$('.main-product__variant-select').val()] == undefined){
    return
  }
  if (variantPricesHint[$('.main-product__variant-select').val()] !== ""){
    $('.variantMessage').html(`${variantPricesHint[$('.main-product__variant-select').val()]}`)
  }
  $('.main-product__variant-select').on('change',function () {
    if(variantPricesHint[$(this).val()] !== ""){
      $('.variantMessage').html(` ${variantPricesHint[$(this).val()]}`)
    }else{
      $('.variantMessage').text(``)
    }
  })

})
document.querySelector('.main-product__variant-select').addEventListener('change', function () {
  document.dispatchEvent( new CustomEvent("variantChanged", { detail: { variantId: this.value } }) );
})

$(document).on('click', '.faq-ques', function(){
  $(this).parents('.tab-content').siblings('.tab-content').find('.faq-content .faq-ques').removeClass('active');
  $(this).parents('.tab-content').siblings('.tab-content').find('.faq-content .faq-ans').slideUp();
  $(this).toggleClass('active');
  $(this).parents('.tab-content').find('.faq-content .faq-ans').slideToggle();
});